import React from 'react';
import { type ILabelActions } from '@cx-web/feature-i18n';

import styles from './LoginSignupButtons.module.css';

type LoginSignupButtonsProps = {
  labelActions: ILabelActions;
  onSignIn?: () => void;
  onSignUp?: () => void;
};

const LoginSignupButtons: React.FC<LoginSignupButtonsProps> = ({ labelActions, onSignIn, onSignUp }) => (
  <div className={styles.container} data-testid="login-signup-buttons">
    <button className={styles.button} data-testid="login-button" onClick={onSignIn} type="button">
      {labelActions.get('LOG_IN')}
    </button>
    <button
      className={[styles.button, styles.signUp].join(' ')}
      data-testid="signup-button"
      onClick={onSignUp}
      type="button"
    >
      {labelActions.get('SIGN_UP')}
    </button>
  </div>
);

export default LoginSignupButtons;
